export default "__VITE_ASSET__C4gZw6hY__"